import HomeSectionTitle from "../Home/components/home-section-title";
import PinnedProject from "./components/pinned-project";

// Admin Page

export default function AdminPage() {
  return (
    <div className="grid-layout pt-50">
      <HomeSectionTitle>Admin Page</HomeSectionTitle>

      {/* list */}
      <div>
        {/* 고정콘텐츠 */}
        <PinnedProject />
      </div>
    </div>
  );
}
